import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { TPostContractorPaymentDeductionRequest } from "./postContractorPaymentDeduction.schema";

export interface IPostContractorPaymentDeductionResponse {
  readonly deductionID: string;
  readonly deductionTemplateID?: string;
  readonly deduction_template_name?: string;
  readonly deduction_credit?: boolean;
  readonly employee_calculated_contribution?: number;
  readonly companyID?: string;
  readonly employeeCheckID?: string;
}

export const postContractorPaymentDeduction = (axios: IAxiosInstance) => {
  return async (
    body: TPostContractorPaymentDeductionRequest
  ): Promise<IPostContractorPaymentDeductionResponse> => {
    const response = await axios.noRetry.post<
      IApiResponse<IPostContractorPaymentDeductionResponse>
    >("/api/contractor-payments/deductions", body);
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to add deduction to contractor payment");
  };
};
